import { ResponseData, SurveyResponseData } from './models/ResponseData'
import { fetchAuthenticated, getAggregateUrl } from './sessionApi'

export const listResponses = (
  surveyId: string
): Promise<SurveyResponseData> => {
  return fetchAuthenticated<SurveyResponseData>(
    getAggregateUrl(`/response/${encodeURIComponent(surveyId)}`),
    {
      method: 'GET',
    }
  )
}
